<template>
    <van-popup v-model:show="show" round position="right" :style="{ padding: '1rem', top: '0', right: '2%', width: '60%' }">
        <van-row gutter="2">
            <van-col span="12" v-for="(item, index) in themesList" :key="index"
                style="padding: 0 10px; text-align: center;">
                <van-image :src="item.imgUrl" width="40" height="90">
                    <template #loading>
                        <div class="loading-box">
                            <van-loading type="spinner" size="20" color="#10b981" />
                        </div>
                    </template>
                </van-image>
                <p style="margin: 0;margin-bottom: 5px;font-size: 0.7rem; color: #fff;">{{ $t(item.name) }}</p>
            </van-col>
        </van-row>
        <div style="text-align: center;">
            <van-radio-group v-model="selectedTheme">
                <van-row gutter="2">
                    <van-col span="12" v-for="(item, index) in themesList" :key="index" style="text-align: center;">
                        <van-radio :name="item.themeIndex" @click="switchTheme(index + 1)"
                            style="display: flex;justify-content: center;" icon-size="14px" checked-color="#8aa360">
                        </van-radio>
                    </van-col>
                </van-row>
            </van-radio-group>
        </div>
    </van-popup>
</template>

<script setup lang="ts">
import { ref, defineExpose } from 'vue'
import StatusPopup from '@/components/common/statusPopup.vue'
import LoadingScreen from '@/components/common/loadingScreen.vue'
import { useI18n } from 'vue-i18n';
import ContactServicePopup from '@/view/profile/contactServicePopup.vue';
import { useThemeStore } from '@/stores/theme';

const { t } = useI18n();
const show = ref(false)
const isSuccess = ref(false)
const statusRef = ref()
const toastContent = ref('')
const loadingRef = ref()
const title = ref('')
const contactRef = ref()
const themeStore = useThemeStore()
const selectedTheme = ref(themeStore.themeIndex)

const themesList = ([{ themeIndex: 1, imgUrl: require('@/assets/theme/themeOne.png'), name: t('header.themeOne') }, { themeIndex: 2, imgUrl: require('@/assets/theme/themeTwo.png'), name: t('header.themeTwo') }])
const open = (value: string) => {
    show.value = true
    title.value = value
}


const close = () => {
    show.value = false
    contactRef.value.close()
}

const showError = (message: string) => {
    toastContent.value = message;
    isSuccess.value = false;
    statusRef.value.open()
}
const showSuccess = (message: string) => {
    toastContent.value = message;
    isSuccess.value = true;
    statusRef.value.open()
}

const openContactPopup = () => {
    contactRef.value.open()
}
const switchTheme = (index: number) => {
    selectedTheme.value = index
    themeStore.setThemeIndex(index)
}
defineExpose({
    open,
    close
})
</script>
<style scoped>
.van-popup--right.van-popup--round {
    border-radius: 10px;
    background: #312734;

}

.van-popup--right {
    transform: unset !important;
}

.popupContainer {
    /* background-image: linear-gradient(147deg, #FEFCE1 0%, #DA8D4E 100%);
    padding: 10px;
    border-radius: 25px;
    width: 70%;
    overflow: hidden; */
}

/* .van-overlay {
    z-index: 9999 !important;
} */
</style>